import styles from './mileage_history.module.scss';
import {formatKm} from '../../../support/format_distance.ts';

interface OwnProps {
    label: string;
    date?: string | null;
    value?: number | null;
}

export function MileageHistoryItem({label, date, value}: OwnProps) {
    return (
        <div className={styles.mileage_history__item}>
            <div className={styles.item__content}>
                <span className={styles.content__label}>{label}</span>
                <span className={styles.content__value}>
                    {value && date ? (
                        <>
                            {date} | {formatKm(value)}
                        </>
                    ) : (
                        <span className={styles.placeholder} />
                    )}
                </span>
            </div>
        </div>
    );
}
